import { QueryParams } from "@/models/query-params.model";
import { StatsRest } from "@/services/rest/stats.rest";
import { GenericsUtils } from "@/utils/generics.util";
import { BehaviorSubject, map } from "rxjs";

export class StudentsService {
  constructor(private _stats = new StatsRest(), private _generics = new GenericsUtils()) {}

  attentionLogs$ = new BehaviorSubject([]);
  attentionLogs = this.attentionLogs$.asObservable();

  getAllAttentionLogs(courseId: string, params: QueryParams): void {
    this._stats
      .getLogsByCourseId(courseId, params)
      .pipe(
        map((e) => {
          e.content.forEach((item) => {
            item.convertDate = this._generics.getDate(item.date);
          });
          return e;
        })
      )
      .subscribe({
        next: (response) => {
          this.attentionLogs$.next(response);
        },
      });
  }
}
